import { GameStatus } from '@draughts/shared';

/**
 * «La schermata che sto guardando ha una partita VIVA sotto?»
 *
 * Una domanda sola, due chiamanti: la conferma d'uscita del gesto indietro
 * (`isGameInProgress` in App, che la interroga dentro il gestore `popstate`) e
 * la consegna della posizione all'editor (`useStudyHandoff`, che nasconde
 * «Studia in editor» finche' una partita e' in corso).
 *
 * Sta qui fuori, pura e con gli stati passati come argomenti, per una ragione
 * precisa: il chiamante del gesto indietro li legge con `getState()` perche' non
 * puo' essere reattivo, quello della review li legge con dei selettori perche'
 * DEVE esserlo. La regola invece e' la stessa, e scritta una volta.
 *
 * ⚠️ **E' chiavata sulla SCHERMATA, e non va trasformata in un «c'e' una partita
 * in corso» globale.** `leaveGameTo` naviga e non azzera `game-store`: chi lascia
 * a meta' una partita contro il computer si porta dietro uno `status` a
 * `'PLAYING'` a tempo indeterminato (lo riazzerano solo una partita nuova e il
 * logout). Un predicato globale spegnerebbe «Studia in editor» in TUTTA
 * l'applicazione dopo una partita locale abbandonata. La review vive sempre
 * dentro la schermata corrente, quindi la schermata e' esattamente il contesto
 * che serve.
 *
 * ⚠️ E non va **stretta** (per esempio aggiungendo `'ended'` fra gli stati
 * online): da qui passa anche la conferma d'uscita, e stringere qui vorrebbe
 * dire chiedere «vuoi davvero uscire?» a chi sta solo guardando un riepilogo.
 */
export interface StatiDiPartita {
  /** `useGameStore.status` — la partita locale (contro il computer o in due sullo stesso schermo). */
  locale: string;
  /** `useMultiplayerStore.status`. */
  online: string;
  /** `useTournamentStore.status`. */
  torneo: string;
  /** `useArenaStore.status`. */
  arena: string;
}

export function laPartitaDellaSchermataEInCorso(gameScreen: string, stati: StatiDiPartita): boolean {
  switch (gameScreen) {
    case 'local-game':
      return stati.locale === GameStatus.PLAYING;
    case 'online-game':
      return stati.online === 'playing';
    case 'tournament-game':
      return stati.torneo === 'playing';
    case 'arena-game':
      // 'gameEnd' è ancora dentro la partita: il riepilogo col punteggio non
      // se ne va da solo, e uscirne è una scelta da confermare come quella di
      // abbandonare una partita. Chi esce comunque non resta a piedi: a fine
      // partita si è in pausa, e la banda dell'arena mostra «Riprendi».
      return stati.arena === 'playing' || stati.arena === 'matchFound' || stati.arena === 'gameEnd';
    default:
      return false;
  }
}
